export default __webpack_public_path__ + "static/media/animation_explorer-icon.2a92a3f0.png";